import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { TransactionDetails } from '../../models'

@Component({
    selector: 'ach-return-info',
    standalone: true,
    imports: [DatePipe],
    templateUrl: './return-info.component.html',
    styleUrl: './return-info.component.scss',
})
/** @deprecated Removed by US-2.20 — dynamic section collapsed to NOC only. Kept for possible revert. */
export class ReturnInfoComponent {
    @Input({ required: true }) details!: TransactionDetails
}
